import { Navigate } from 'react-router-dom';

import { history, isAdmin } from '../helpers';

// AdminRoute 在 PrivateRoute 之上叠加角色检查：
//   - 未登录 → /login
//   - 已登录但非 admin/root → /
//
// 放在路由层做守卫，避免非 admin 用户通过深链接 / 收藏夹进入 admin-only
// 页面（如 /channel）时，页面组件在拉数据阶段才踩到 401/403 报未捕获错误。
function AdminRoute({ children }) {
  if (!localStorage.getItem('user')) {
    return <Navigate to='/login' state={{ from: history.location }} />;
  }
  if (!isAdmin()) {
    return <Navigate to='/' replace />;
  }
  return children;
}

export { AdminRoute };
